export default {
  common: {
    clearAll: '全部清除',
    restart: '重启'
  },
  download: {
    bodyText: '点击下面的下载链接以下载%{products}',
    bothProducts: 'PlayBase 和/或 Nexus',
    bodyTextFromAcceptInvitation:
      '这个过程需要一些时间。与此同时，您可以像往常一样继续使用Metrica Sports。',
    bodyTextFromDeclineInvitation: '你已拒绝邀请！点击下面的下载链接以下载 %{products}',
    bodyTextFromTrial:
      '欢迎使用您的试用设置！请检查您注册的电子邮件以获取验证链接（检查垃圾邮件文件夹）。',
    bodyTitle: '下载',
    bodyTitleFromAcceptInvitation: '我们正在切换您的账户',
    bodyTitleFromDeclineInvitation: '邀请被拒绝',
    bodyTitleFromTrial: '注册完成',
    play2: {
      description:
        'Metrica PlayBase 是一款直观的分析工具，专为业余和半专业教练、小型俱乐部和独立分析师设计。它简化了性能评估过程，使之对所有人都易于访问。',
      keyFeature1: {},
      keyFeature2: {},
      keyFeature3: {},
      keyFeature4: {},
      plan1: {},
      plan2: {}
    },
    play3: {
      description:
        'Metrica Nexus 专为寻求全面绩效洞察的精英分析师和教练量身定制。拥有先进工具在您的指尖，您可以增强团队策略并推动成功。',
      keyFeature1: {},
      keyFeature2: {},
      keyFeature3: {},
      keyFeature4: {},
      plan1: {},
      plan2: {}
    },
    thanks: '感谢您注册Metrica Sports！要开始您的试用，请下载%{products}。'
  },
  error: {
    restart: '看来你正在尝试进入我们仍在开发的东西...',
    tryAgainMsg: '请重试，如果此错误仍然存在，请联系 Metrica Sports 支持团队'
  },
  verifyEmail: {
    generateLink: '登录 Play 生成新链接',
    readyToLogin: '您已准备好登录 Play',
    successfully: '电子邮件已成功验证',
    unsuccessfully: '验证电子邮件时出错，令牌无效'
  }
}
